import React, { useState, useEffect } from 'react';
import { Auth, Hub } from "aws-amplify";
import { CognitoUser } from "amazon-cognito-identity-js";

export interface LoginContextType {
    ready: boolean
    login?: boolean | undefined
    cognitoUser?: CognitoUser | undefined
}

export const LoginContext = React.createContext<LoginContextType>({
    ready: false
})

interface Props {
    children: any
}

export const LoginContextProvider = (props: Props) => {

    const setLogin = (login: boolean) => {
        setState({ ...state, login})
    }

    const initState = {
        ready: false,
        login: false,
        setLogin: setLogin
    }

    const [event, setEvent] = useState<string | undefined>()
    Hub.listen("auth", msg=>setEvent(msg?.payload?.event))

    const [state, setState] = useState<LoginContextType>(initState)
    useEffect(()=>{
        console.log("Login effect")
        const func = async () => {
            console.log("Login in")
            try {
                const cred = await Auth.currentAuthenticatedUser()
                console.log(cred?.attributes?.email)
                setState({
                    ready: true,
                    login: true,
                    cognitoUser: cred,
                })
            }
            catch (e) {
                console.log("Login out")
                // not authenticated
                if (e === "not authenticated") {
                    setState({
                        ready: true,
                        login: false,
                        cognitoUser: undefined,
                    })
                }
                else {
                    throw e
                }
            }
        }
        func()
    },[event])



    return (
        <LoginContext.Provider value={state}>
            {props.children}
        </LoginContext.Provider>
    )
}

export default LoginContextProvider